module.exports = __webpack_public_path__ + "static/media/scb.98974af8.png";